import React from 'react'
import styled from 'styled-components'


const Icon = styled.span`
    display: inline-block;
    vertical-align: middle;
    svg {
        vertical-align: top;
    }
`

export default Icon
